import React, { Component } from 'react';
import { connect } from 'react-redux';

import NoData from '../../../components/NoData/NoData';
import { DatePicker, Options } from '../../../components/Filter/components';
import DetailsAccordion from '../../../components/DetailsAccordion/CTHDetailsAccordion';

import CTHChart from './CTHChart';
import AvgCycleTime from './AvgCycleTime';

import '../CTH.scss';

class WallboardCTHChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPoint: {}
    };
  }

  handlePointClick = point => {
    this.setState({
      selectedPoint: point
    });
  };

  render() {
    return (
      <div className="content-wrap">
        <div className="dashboard_head">
          <h1>Cycle Time Histogram</h1>
          <div className="button_tools">
            <Options chart="cth" showNavigator showAvgChart options={{ avgChartTooltip: 'Cycle Time Averages' }} />
            <DatePicker />
          </div>
        </div>
        <div className="dashboard_details">
          {this.props.data.series && !!this.props.data.series.length && this.props.avgChart && (
            <AvgCycleTime data={this.props.data.series} dateFormat={this.props.dateFormat} />
          )}
          <DetailsAccordion id="details-accordion" data={this.state.selectedPoint} />
        </div>
        {this.props.isFatTailed !== undefined && (
          <div
            style={{
              marginLeft: '40px',
              marginTop: '-20px'
            }}
          >
            <span>{this.props.isFatTailed ? 'Fat-Tailed Distribution' : 'Thin-Tailed Distribution'}</span>
          </div>
        )}
        <div className="diagram_details">
          <CTHChart id="CTH" data={this.props.data} onPointClick={this.handlePointClick} />
          <NoData show={this.props.data.series && !this.props.data.series.length} loading={this.props.isLoading} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    dateFormat: state.filters.dateFormat,
    avgChart: state.filters.cth.avgChart,
    data: state.cth.data,
    isLoading: state.cth.isLoading,
    isFatTailed: state.cth.isFatTailed,
    dashboard: state.dashboards.selected
  };
};

export default connect(mapStateToProps)(WallboardCTHChart);
